import React from 'react'
import { BusyButton } from '@ztechapps/webui.button'
import { useFormikContext } from 'formik'

export const SubmitButton = ({ text = 'Register' }: any) => {
  const { isSubmitting, handleSubmit } = useFormikContext()

  return <BusyButton onClick={handleSubmit} bsStyle="primary" isBusy={isSubmitting} text={text} />
}
